import { twMerge } from "tailwind-merge";
import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { Icon } from "../../../components";
import { useState } from "react";
import { useSupplierRelationshipUpdate } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  DataButton,
  Dialog,
  H3,
  H6,
  InputLabel,
  InputContainer,
  InputText,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";

export const BusinessConnectionCustomerCode = ({
  connection,
}: {
  connection: SupplierRelationshipGetResponseType;
}) => {
  const [editActive, setEditActive] = useState(false);

  return (
    <>
      <Card className="bg-white">
        <CardHeader
          className={twMerge("bg-white", "flex items-center justify-between")}
        >
          <div>
            <H3>Customer code</H3>
            <H6>For your internal reference</H6>
          </div>

          <DataButton border={true} onClick={() => setEditActive(true)}>
            <Icon icon={"PENCIL"} />
            Edit
          </DataButton>
        </CardHeader>
        <CardContent>
          <p>{connection.customerCode}</p>
        </CardContent>
      </Card>
      <EditDialog
        active={editActive}
        setActive={setEditActive}
        connection={connection}
      />
    </>
  );
};

const EditDialog = ({
  active,
  setActive,
  connection,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  connection?: SupplierRelationshipGetResponseType;
}) => {
  const [code, setCode] = useState<string | undefined>(
    connection?.customerCode ?? undefined,
  );
  const [previousConnection, setPreviousConnection] = useState(connection);
  if (connection !== previousConnection) {
    setPreviousConnection(connection);
    setCode(connection?.customerCode ?? undefined);
  }

  const updateConnectionMutation = useSupplierRelationshipUpdate(
    connection?.id ? connection.id : 0,
  );

  const loading = updateConnectionMutation.isPending;

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Edit Customer code"
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();

          updateConnectionMutation.mutate(
            {
              customerCode: code,
            },
            {
              onSuccess: () => {
                setActive(false);
              },
            },
          );
        }}
        className="flex flex-col gap-2"
      >
        <DialogContent className="flex flex-col gap-4">
          <InputLabel>Customer code</InputLabel>
          <InputContainer>
            <InputText value={code} onChange={(e) => setCode(e.target.value)} />
          </InputContainer>
        </DialogContent>
        <DialogCTA>
          <Button type="submit" loading={loading}>
            Confirm
          </Button>
        </DialogCTA>
      </form>
    </Dialog>
  );
};
